/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../../assets/styles/custom-style.css";

const NoAddressFound = () => {
  const navigate = useNavigate();

  const redirectToAddress = () => {
    navigate("/settings/profile-details"); // Change this path to the actual address update page
  };

  return (
    <section className="container-fluid">
      <div className="row">

        <div className="overlay"></div>
        <div className="drawer small add-dish">
          <div className="alert-wrap">
            <img
              className="ico mb-4"
              src="/assets/images/alert-warning-ico.svg"
              alt="success"
            />
            <h1 className="mb-3 text-danger">No Address Found</h1>
            <p className="mid-gray mb-4">
              <small>
                You haven't added an address yet. Please update your address before proceeding.
              </small>
            </p>
            <button className="btn btn-primary rounded-5 px-4" onClick={redirectToAddress}>
              Update Address
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NoAddressFound;
